export const TIMEZONE_OPTIONS = [
  ["UTC-12:00", "Pacific/Pago_Pago", "American Samoa"],
  ["UTC-11:00", "Pacific/Midway", "Niue, Samoa (old)"],
  ["UTC-10:00", "Pacific/Honolulu", "Hawaii"],
  ["UTC-09:00", "America/Anchorage", "Alaska"],
  ["UTC-08:00", "America/Los_Angeles", "Pacific Time (US & Canada)"],
  ["UTC-07:00", "America/Denver", "Mountain Time (US & Canada)"],
  ["UTC-06:00", "America/Chicago", "Central Time (US & Canada)"],
  ["UTC-05:00", "America/New_York", "Eastern Time (US & Canada)"],
  ["UTC-04:00", "America/Santiago", "Chile, Atlantic Time"],
  ["UTC-03:00", "America/Sao_Paulo", "Brazil, Argentina"],
  ["UTC-02:00", "Atlantic/South_Georgia", "South Georgia"],
  ["UTC-01:00", "Atlantic/Azores", "Azores"],
  ["UTC±00:00", "Europe/London", "United Kingdom, Portugal"],
  ["UTC+01:00", "Europe/Paris", "Central Europe, West Africa"],
  ["UTC+02:00", "Europe/Athens", "Eastern Europe, South Africa"],
  ["UTC+03:00", "Europe/Moscow", "Russia, East Africa"],
  ["UTC+04:00", "Asia/Dubai", "UAE, Armenia"],
  ["UTC+05:00", "Asia/Karachi", "Pakistan"],
  ["UTC+05:30", "Asia/Kolkata", "India"],
  ["UTC+06:00", "Asia/Dhaka", "Bangladesh"],
  ["UTC+07:00", "Asia/Bangkok", "Thailand, Vietnam"],
  ["UTC+08:00", "Asia/Singapore", "China, Singapore"],
  ["UTC+09:00", "Asia/Tokyo", "Japan, Korea"],
  ["UTC+10:00", "Australia/Sydney", "Eastern Australia"],
  ["UTC+11:00", "Pacific/Guadalcanal", "Solomon Islands"],
  ["UTC+12:00", "Pacific/Auckland", "New Zealand"],
  ["UTC+13:00", "Pacific/Tongatapu", "Tonga"],
  ["UTC+14:00", "Pacific/Kiritimati", "Line Islands (Kiribati)"],
].map(([offset, timezone, city]) => ({
  offset,
  timezone,
  city,
  value: timezone,
  label: `${offset} - ${timezone} - ${city}`,
}));
